export default __webpack_public_path__ + "static/favicon-1d22d37cc3c1dbef51289ded71e5c65a.ico";